/* global IntersectionObserver */

import deviceMenu from '@js/common/deviceMenu.js';
import {
    appendSVGBtn,
    replaceHashLinks,
    slideToggle,
    headeraddClass,
    updateFocusedClass,
} from '@js/common/customFunctions.js';

// const header = document.querySelector('header.main-header');

deviceMenu();
/* Script on ready
------------------------------------------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {

    initVideoLazyLoad();

    setTimeout(() => {
        document.querySelectorAll('iframe[data-src]').forEach((iframe) => {
            let src = iframe.dataset.src;

            if (!src) {return;}

            // If autoplay=1 already exists → do nothing
            if (src.includes('autoplay=1')) {
                iframe.src = src;
                return;
            }

            // If autoplay=0 exists → replace it
            if (src.includes('autoplay=0')) {
                src = src.replace('autoplay=0', 'autoplay=1');
            } else {
                // If autoplay param doesn't exist → add it
                const separator = src.includes('?') ? '&' : '?';
                src += separator + 'autoplay=1';
            }

            iframe.src = src;
        });
    }, 500);

    /* Process buttons */
    document.querySelectorAll('.btn-link, .btn-play').forEach(function(element) {
        if (element.classList.contains('btn-link')) {
            appendSVGBtn(element, '#icon-btn-arrow', '24', '15');
        } else if (element.classList.contains('btn-play')) {
            appendSVGBtn(element, '#icon-play-btn', '10', '13');
        }
    });

    // Gravity Forms render
    jQuery(document).on('gform_post_render', addButtonDots);
    /* Process menu */

    document.querySelectorAll('.menu-content .menu-wrap').forEach((el) => {
        const link = el.querySelector('a');
        const p = el.querySelector('p');

        if (link && p) {
            link.appendChild(p);
        }
    });

    /* change header on scroll */
    function updateHeaderTheme() {
        const header = document.querySelector('header');
        const sections = document.querySelectorAll('section , div.bg-dark');

        if (!header) {
            return;
        }

        const headerHeight = header.offsetHeight;
        const triggerPoint = headerHeight / 2;

        let activeSection = null;

        sections.forEach((section) => {
            const rect = section.getBoundingClientRect();

            if (rect.top <= triggerPoint && rect.bottom >= triggerPoint) {
                activeSection = section;
            }
        });

        if (!activeSection) {
            return;
        }

        if (
            activeSection.classList.contains('capabilities-promo-section') ||
            activeSection.classList.contains('bg-dark') ||
            activeSection.classList.contains('case-study-detail-hero')
        ) {
            header.classList.add('light');
            header.classList.remove('dark');
        } else {
            header.classList.add('dark');
            header.classList.remove('light');
        }
    }

    let ticking = false;

    window.addEventListener('scroll', () => {
        if (!ticking) {
            window.requestAnimationFrame(() => {
                updateHeaderTheme();
                ticking = false;
            });
            ticking = true;
        }
    });
    window.addEventListener('DOMContentLoaded', updateHeaderTheme);
    window.addEventListener('resize', updateHeaderTheme);

    /* Show search bar on click start */

    const searchButton = document.querySelector(
        'header.main-header .header-search .header-search-btn',
    );
    const searchWrap = document.querySelector(
        'header.main-header .h-search-wrap',
    );
    const body = document.body;

    searchButton.addEventListener('click', function() {
        this.classList.toggle('is-click');
        searchWrap.classList.toggle('is-open');
        body.classList.toggle('scroll-fixed');

        setTimeout(() => {
            const searchInput = searchWrap.querySelector('input[type="search"]');
            if (searchInput) {
                searchInput.focus();
            }
        }, 100);
    });

    // Hide search bar on click
    const overlay = document.querySelector(
        'header.main-header .h-search-overlay',
    );
    const closeButton = document.querySelector(
        'header.main-header .h-search-close',
    );

    function closeSearchPanel() {
        searchButton.classList.remove('is-click');
        searchWrap.classList.remove('is-open');
        body.classList.remove('scroll-fixed');
    }

    if (overlay) {
        overlay.addEventListener('click', closeSearchPanel);
    }
    if (closeButton) {
        closeButton.addEventListener('click', closeSearchPanel);
    }

    if (document.body.classList.contains('search')) {
        const searchPage = document.querySelectorAll('.search-result-page');
        searchPage.forEach((section) => {
            const clearBtn = section.querySelector('.search-clear');
            const searchInput = section.querySelector('input[name="s"]');

            if (clearBtn) {
                clearBtn.addEventListener('click', function() {
                    if (searchInput) {
                        searchInput.value = '';
                    }
                    document.getElementById('filter_form').submit();
                });
            }
        });
    }

    // Footer
    const footerLinks = document.querySelectorAll(
        '.main-footer ul.footer-menu > li.menu-item-has-children > a',
    );
    footerLinks.forEach((link) => {
        if (!link.querySelector('.down-arrow')) {
            const span = document.createElement('span');
            span.className = 'down-arrow';

            // Wrap the <a> tag and .down-arrow in a new div with class 'menu-item-wrap'
            const menuItemWrap = document.createElement('div');
            menuItemWrap.className = 'menu-item-wrap';
            link.parentNode.insertBefore(menuItemWrap, link);
            menuItemWrap.appendChild(link);
            menuItemWrap.appendChild(span);
        }
    });

    if (window.innerWidth < 768) {
        footerLinks.forEach((link) => {
            // Add event listener to the down-arrow to toggle the submenu
            const downArrow = link.parentNode;
            if (downArrow) {
                downArrow.addEventListener('click', function(e) {
                    e.stopPropagation();
                    const menuItem = link.closest('.menu-item');
                    const subMenu = menuItem.querySelector('.sub-menu');

                    if (subMenu) {
                        menuItem.classList.toggle('is-active');
                        slideToggle(subMenu);
                    }
                });
            }
        });
    }

    /************************************
     ******** All Function Start *********
     ************************************/
    headeraddClass();
    handleResponsiveTables();
    /* Menu Link change "#" to "javascript:void(0);" start */
    // replaceHashLinks('header.main-header ul.menu > li');
    replaceHashLinks('footer.main-footer ul.footer-menu > li');
    replaceHashLinks('footer.main-footer ul.quick-link-menu > li');
    /* Menu Link change "#" to "javascript:void(0);" end */
    /***********************************
     ******** All Function End **********
     ************************************/
});

window.addEventListener('load', () => {
    // buttons
    addButtonDots();

    // mutation observer
    const ariaObserver = new MutationObserver(addButtonDots);

    ariaObserver.observe(document.body, {
        childList: true,
        subtree: true,
    });

    // tables
    handleResponsiveTables();
});

/* Use jQuery code Start
------------------------------------------------------------------------------*/

(function($) {
    // Write code here
    $('.back-to-top').on('click', function(e) {
        e.preventDefault();

        $('html, body').animate({
            scrollTop: 0,
        },
        600,
        );
    });

    /* Form focus Function Start */
    const initFormFocus = () => {
        const fields = document.querySelectorAll(
            '.contact-form .cf-form .gfield input, \
        .contact-form .cf-form .gfield textarea, \
        .contact-form .cf-form .gfield select',
        );

        if (fields.length) {
            updateFocusedClass(fields);
        }
    };

    // Run on page load
    document.addEventListener('DOMContentLoaded', initFormFocus);

    // Run again after Gravity Forms AJAX render
    if (window.jQuery) {
        jQuery(document).on('gform_post_render', function() {
            initFormFocus();
        });
    }
    /* Form focus Function End */

    // Social Icon
    document.querySelectorAll('a').forEach(function(element) {
        if (element.classList.contains('heateor_sss_button_linkedin')) {
            appendSVGBtn(element, '#icon-linkedin', '32', '32');
        } else if (element.classList.contains('heateor_sss_button_x')) {
            appendSVGBtn(element, '#icon-twitter', '32', '31');
        } else if (element.classList.contains('heateor_sss_facebook')) {
            appendSVGBtn(element, '#icon-facebook', '24', '44');
        } else if (element.classList.contains('heateor_sss_more')) {
            appendSVGBtn(element, '#icon-share', '32', '48');
        }
    });

    document
        .querySelectorAll('.heateor_sss_sharing_ul > a')
        .forEach(function(el) {
            el.removeAttribute('style');
        });

    /* Tab outline start */
    $(document).on('keyup', 'a, button', function(e) {
        $(this).each(function() {
            if (e.key === 'Tab' || e.keyCode === 9) {
                if (!$(this).parents('nav').length) {
                    $('.menu-focus').removeClass('menu-focus');
                }
                $('.tab-outline').removeClass('tab-outline');
                $(this).addClass('tab-outline');
                if ($(this).parent('li').find('ul').length > 0) {
                    $(this)
                        .parent()
                        .addClass('menu-focus')
                        .siblings()
                        .removeClass('menu-focus');
                } else {
                    if (
                        !$(this).parents('.menu-item-has-children').hasClass('menu-focus')
                    ) {
                        $('.menu-focus').removeClass('menu-focus');
                    }
                }
            }
        });
    });

    $(document).on('keydown', function(event) {
        if (event.key === 'Escape') {
            $('.is-click').removeClass('is-click');
            $('.is-open').removeClass('is-open');
            $('.scroll-fixed').removeClass('scroll-fixed');
            $('.is-active').removeClass('is-active');
        }
    });

    $(document).on('click', function() {
        $('.tab-outline').removeClass('tab-outline');
        $('.menu-focus').removeClass('menu-focus');
    });
    /* Tab outline end */

    /* Scroll To ID */
    const mainHeader = $('header.main-header');
    if (window.location.hash) {
        const targetId = window.location.hash.substring(1);
        const targetElement = $('#' + targetId);

        if (targetElement.length) {
            $('html, body').animate({
                scrollTop: targetElement.offset().top - mainHeader.outerHeight() - 10,
            },
            1000,
            );
        }
    }

    $('a').each(function() {
        const hrefValue = $(this).attr('href');

        // Check if the href starts with '#'
        if (hrefValue && hrefValue.startsWith('#')) {
            // Run your script here
            $(this).on('click', function(event) {
                event.preventDefault();
                const targetId = hrefValue.substring(1);

                const targetElement = $('#' + targetId);
                if (targetElement.length) {
                    $('html, body').animate({
                        scrollTop: targetElement.offset().top - mainHeader.outerHeight() - 10,
                    },
                    500,
                    );
                }
            });
        }
    });
})(jQuery);

/* ------------------------------------------------------------------------------
Use jQuery code End */

/* dynamic header height */

let initialHeaderHeight = 0;

function setHeaderHeight() {
    const header = document.querySelector('header.main-header');
    const heroSection = document.querySelector('.homepage-hero-section');

    if (!header) {
        return;
    }

    if (!initialHeaderHeight) {
        initialHeaderHeight = header.offsetHeight;
    }

    if (heroSection) {
        heroSection.style.setProperty(
            '--header-height',
            `${initialHeaderHeight}px`,
        );
    }

    const mhTop = header.querySelector('.mh-top');
    const mhBottom = header.querySelector('.mh-bottom');

    let totalHeight = 0;

    function getVisibleHeightWithMargin(el) {
        if (!el) {
            return 0;
        }

        const rect = el.getBoundingClientRect();
        const styles = window.getComputedStyle(el);

        const marginTop = parseFloat(styles.marginTop) || 0;
        const marginBottom = parseFloat(styles.marginBottom) || 0;

        let visibleHeight = 0;

        if (rect.bottom > 0 && rect.top < window.innerHeight) {
            visibleHeight =
                Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);
        }

        return visibleHeight + marginTop + marginBottom;
    }

    totalHeight += getVisibleHeightWithMargin(mhTop);
    totalHeight += getVisibleHeightWithMargin(mhBottom);

    header.style.setProperty('--header-height', `${totalHeight + 24}px`);
}

window.addEventListener('load', setHeaderHeight);
window.addEventListener('resize', setHeaderHeight);
window.addEventListener('scroll', setHeaderHeight);

// Add role="button" and tabindex="0" to links with href="#" or "javascript:void(0);"
document
    .querySelectorAll('a[href="#"], a[href="javascript:void(0);"]')
    .forEach(function(el) {
        el.setAttribute('role', 'button');
        el.setAttribute('tabindex', '0');

        // Keyboard support (Enter + Space)
        el.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                el.click();
            }
        });
    });

function addButtonDots() {
    const buttons = document.querySelectorAll(
        '.btn, .button, .wp-block-button__link, .gform_button , .cky-btn , .cky-show-desc-btn , .cky-accordion-btn , .cky-accordion-btn',
    );

    buttons.forEach(function(button) {
        if (!button.querySelector('.btn-dot')) {
            const dotLeft = document.createElement('span');
            dotLeft.classList.add('btn-dot', 'btn-dot-left');

            const dotRight = document.createElement('span');
            dotRight.classList.add('btn-dot', 'btn-dot-right');

            button.insertBefore(dotLeft, button.firstChild);
            button.appendChild(dotRight);
        }
    });
}

/* TABLE RESPONSIVE SCRIPT WITH RESIZE SUPPORT */
function wrapTables() {
    document
        .querySelectorAll('table, .accordion-component table')
        .forEach(function(table) {
            if (!table.parentElement.classList.contains('table-wrapper')) {
                const wrapper = document.createElement('div');
                wrapper.className = 'table-wrapper';
                table.parentNode.insertBefore(wrapper, table);
                wrapper.appendChild(table);
            }
        });
}

function buildMobileTableView(wrapper) {
    const table = wrapper.querySelector('table');
    if (!table || wrapper.querySelector('.mobile-table-view')) {
        return;
    }

    const rows = table.querySelectorAll('tbody tr');
    if (rows.length === 0) {
        return;
    }

    const numColumns = rows[0].children.length;
    const columns = Array.from({
        length: numColumns,
    },
    () => [],
    );

    rows.forEach((row, rowIndex) => {
        Array.from(row.children).forEach((cell, colIndex) => {
            columns[colIndex].push({
                isHeader: rowIndex === 0,
                content: cell.innerHTML.trim(),
            });
        });
    });

    const mobileView = document.createElement('div');
    mobileView.className = 'mobile-table-view';

    columns.forEach((colData) => {
        const colBlock = document.createElement('div');
        colBlock.className = 'column-block';

        colData.forEach((cell, index) => {
            const div = document.createElement('div');
            div.className = cell.isHeader ? 'column-header' : 'column-cell';
            div.innerHTML = cell.content;
            colBlock.appendChild(div);
        });

        mobileView.appendChild(colBlock);
    });

    table.insertAdjacentElement('afterend', mobileView);
}

function handleResponsiveTables() {
    wrapTables();

    document.querySelectorAll('.table-wrapper').forEach((wrapper) => {
        const isMobile = window.innerWidth <= 992;
        const hasMobileView = wrapper.querySelector('.mobile-table-view');

        if (isMobile && !hasMobileView) {
            buildMobileTableView(wrapper);
        }

        if (!isMobile && hasMobileView) {
            wrapper.querySelector('.mobile-table-view').remove();
        }
    });
}

window.addEventListener('resize', () => {
    clearTimeout(window._tableResizeTimeout);
    window._tableResizeTimeout = setTimeout(handleResponsiveTables, 200);
});
/* TABLE RESPONSIVE SCRIPT WITH RESIZE SUPPORT */

let videoObserver;

function initVideoLazyLoad() {
    if (!videoObserver) {
        videoObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) {return;}

                const el = entry.target;
                let src = el.dataset.src;

                if (!src) {
                    observer.unobserve(el);
                    return;
                }

                src = src.replace(/&amp;|&#038;/g, '&');

                // Add autoplay=1
                if (src.includes('autoplay=0')) {
                    src = src.replace('autoplay=0', 'autoplay=1');
                } else if (!src.includes('autoplay=')) {
                    const separator = src.includes('?') ? '&' : '?';
                    src += separator + 'autoplay=1';
                }

                const iframe = document.createElement('iframe');
                iframe.src = src;
                iframe.setAttribute('data-src', src);
                iframe.className = 'video-inner';
                iframe.setAttribute('frameborder', '0');
                iframe.setAttribute('allow', 'autoplay; fullscreen');
                iframe.setAttribute('allowfullscreen', '');
                iframe.loading = 'lazy';

                observer.unobserve(el);

                requestAnimationFrame(() => {
                    el.replaceWith(iframe);
                });
            });
        }, {
            rootMargin: '200px',
            threshold: 0.1,
        });
    }

    document.querySelectorAll('.video-box').forEach((el) => {
        if (!el.dataset.observed) {
            el.dataset.observed = '1';
            videoObserver.observe(el);
        }
    });
}
window.addEventListener('load', initVideoLazyLoad);